import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "__report-lesson" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_4 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_7 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_8 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_9 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Tháng "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Buổi học "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Kết quả "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Ngày áp dụng "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Gửi phụ huynh "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " PH đã xem ")
  ])
], -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "px-6 py-4 text-neutral-700" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "px-3 py-4 whitespace-nowrap text-neutral-700"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  class: "px-3 py-4 whitespace-nowrap text-neutral-700",
  style: {"width":"150px"}
}
const _hoisted_19 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_22 = { class: "w-40" }
const _hoisted_23 = { class: "flex flex-nowrap items-center pr-10" }
const _hoisted_24 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_26 = {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}
const _hoisted_27 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.monthlyReports && _ctx.monthlyReports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthlyReports, (list, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(list.title), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                              _hoisted_10,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.data, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    onClick: ($event: any) => (
													item?.state ===
														'completed' &&
														_ctx.$router.push({
															path: `/report/monthly-report/${item.student_id}`,
															query: {
																..._ctx.$route.query,
																month_start:
																	item?.month_start,
																student_id:
																	item
																		?.student
																		?.id,
															},
														})
												),
                                    key: item.id,
                                    class: _normalizeClass([
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "text-neutral-700 hover:bg-orange-50 cursor-pointer"])
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_12, [
                                        (
																item.month_start
															)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$filters.toMonth(
																	item.month_start
																)), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_14, [
                                      (
															item?.lesson_count
														)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item?.lesson_count), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    false
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                          (item?.skill_count)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item?.goal_count), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", _hoisted_18, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", {
                                          class: "mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-sm shadow-input",
                                          style: _normalizeStyle({
																background:
																	_ctx.$filters.tagResult(
																		item?.average_result_in_percent
																	)
																		?.background,
																color: _ctx.$filters.tagResult(
																	item?.average_result_in_percent
																)?.color,
															})
                                        }, " Đạt " + _toDisplayString(item?.average_result_in_percent) + " % ", 5)
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_19, [
                                      (item?.apply_date)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$filters.formatDate2(
																item?.apply_date
															)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.sent_at
															? 'Đã gửi'
															: '-'), 1),
                                    _createElementVNode("td", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, _toDisplayString(item.numbers_of_parent_read ||
															0) + "/ " + _toDisplayString(item.total_parent_count ||
															0), 1)
                                    ])
                                  ], 10, _hoisted_11))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.isInfinityLoading)
                  ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                      key: 0,
                      onInfiniteLoad: _ctx.getMonthlyReports,
                      loaded: _ctx.stopLoad,
                      "is-loading": _ctx.isLoading
                    }, null, 8, ["onInfiniteLoad", "loaded", "is-loading"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, " Báo cáo tháng được tạo tự động dựa vào các báo cáo buổi học cá nhân trong tháng. Bạn hãy bắt đầu báo cáo các buổi học can thiệp trên app " + _toDisplayString(_ctx.$filters.terminology('teacher')) + ", để có thể làm báo cáo tháng cho học sinh dựa vào những báo cáo đó nhé. ", 1)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_Loading)
        ]))
  ]))
}